module.exports = __webpack_public_path__ + "img/logo-dark.912f80a1.svg";